<template>
  <div
    v-if="questionGroup"
    class="
      question-wrapper
      flex
      list-questions
      align-item-start
      w-full
    "
  >
    <img
      v-if="questionGroupImageUrl"
      class="list-questions__image"
      :src="questionGroupImageUrl"
      alt="Картинка"
    />
    <div class="list-questions__text-block">
      <p class="list-questions__description">{{ questionGroup.text }}</p>
      <div v-if="questionGroup.questions" class="w-full">
        <div
          v-for="question in questionGroup.questions"
          :key="question.id"
          class="list-questions__answer"
        >
          <p v-if="question.text" class="list-questions__text">
            {{ question.text }}
          </p>
          <div class="list-questions__btns flex flex-column w-full">
            <div
              v-for="answer in question.answers"
              :key="answer.id"
              class="list-questions__radio-wrap flex"
            >
              <label :for="`answer_${question.id}_${answer.id}`">{{
                answer.text
              }}</label>
              <input
                :id="`answer_${question.id}_${answer.id}`"
                :name="`answer_${question.id}`"
                type="radio"
                tabindex="1"
                @change="setAnswer"
                :value="answer.value"
                :data-answer="answer.id"
                :data-question="question.id"
                :checked="savedAnswersMap[question.id] === answer.id"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { toRef } from "@vue/reactivity";
import {computed, watch} from "@vue/runtime-core";
import useAnswers from "@/mixins/useAnswers";
export default {
  name: "list-question-group",
  props: {
    questionGroup: {
      type: Object,
    },
    missedGroup: {
      type: Number,
      default: 0,
    },
    savedAnswers: {
      type: Array,
      default: () => [],
    },
    questionGroupImageUrl: {
      type: String,
      default: "",
    }
  },
  setup(props, context) {
    const group = toRef(props, "questionGroup");
    const missedGroup = toRef(props, "missedGroup");
    const { setAnswer, clearAnswers } = useAnswers(context);

    const savedAnswersMap = computed(() => {
      const map = {};

      for (const item of props.savedAnswers) {
        map[item.question_id] = item.question_answer_id;
      }

      return map;
    });

    watch(group, () => {
      clearAnswers();
    });

    watch(missedGroup, () => {
      if (missedGroup.value === group.value.id) {
        clearAnswers();
      }
    });

    return {
      setAnswer,
      savedAnswersMap
    };
  },
};
</script>

<style lang="scss" scoped>
.question-wrapper {
  column-gap: 20px;

  @media (max-width: $tablet-breakpoint) {
    flex-direction: column;
  }
}

.list-questions {
  &__image {
    display: block;
    max-width: 600px;
    max-height: 300px;
    margin-bottom: 15px;
    border-radius: 4px;
    -o-object-fit: cover;
    object-fit: cover;
    object-position: center;
  }

  &__description {
    font-size: 16px;
    font-weight: 600;
  }

  &__answer {
    background-color: var(--light-grey);
    border-radius: 10px;
    padding: 16px;
    width: 100%;
    max-width: 800px;
    margin: 8px 0;
  }

  &__text {
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
    margin: 0 0 15px;
    white-space: break-spaces;
    word-break: break-word;
  }

  &__text-block {
    width: 100%;
    max-width: 800px;
  }

  &__btns {
    row-gap: 12px;
  }

  &__radio-wrap {
    position: relative;
    flex: 1;
    flex-direction: row-reverse;
    column-gap: 8px;

    label {
      display: block;
      text-align: left;
      flex: 1 0;
      word-break: keep-all;
      font-size: 16px;
      padding: 0 20px 0 5px;
      white-space: break-spaces;
    }

    input {
      width: 16px;
      height: 16px;
      display: block;
      background-color: #fff;
      border: 1px solid var(--cream-color);
      border-radius: 50%;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      cursor: pointer;
      margin-top: 5px;
      position: relative;
      z-index: 2;
    }

    input:hover,
    input:focus {
      border-color: var(--main-green) !important;
    }

    input:checked {
      background-color: #fff !important;
      border: 1px solid var(--main-green) !important;
    }

    input:checked::after {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      width: 8px;
      height: 8px;
      transform: translate(-50%, -50%);
      background: var(--main-green);
      border-radius: 50%;
    }
  }

  @media (max-width: $tablet-breakpoint) {
    &__answer {
      width: 100%;
    }
  }

  @media (max-width: $mobile-breakpoint) {
    &__image {
      max-width: 90%;
    }

    &__description {
      font-size: 16px;
    }
  }

  @media (max-width: 560px) {
    &__radio-wrap {
      label {
        font-size: 16px;
      }
    }
  }
}
</style>
